module.exports = __webpack_public_path__ + "img/昆布.a4b3aa96.jpg";